import { contractorsAPI } from "@/views/Contractors/services/api";

export const getHandbookContractors = async (params) => {
  try {
    const res = await contractorsAPI.getList(params);
    return res?.data;
  } catch (e) {}
};

export const sendTo1C = async (contractor_id) => {
  try {
    const response = await contractorsAPI.send1C(contractor_id);
    return response;
  } catch (error) {}
};

export const addHandbookContractor = async (body = {}) => {
  const formData = new FormData();

  Object.entries(body).forEach(([key, value]) => {
    if (key === "document" && value?.length) {
      formData.append(key, value[0]);
    } else {
      formData.append(key, value);
    }
  });

  try {
    const res = await contractorsAPI.addContractor(formData);
    return res?.data;
  } catch (e) {}
};

export const updateHandbookContractor = async (contractor_id, body = {}) => {
  const formData = new FormData();

  Object.keys(body).map((key) => {
    if (key === "document" && body.document?.length) {
      formData.append(key, body.document[0]);
    } else formData.append(key, body[key]);
  });
  try {
    const res = await contractorsAPI.updateContractor(contractor_id, formData);
    return res?.data;
  } catch (e) {}
};
export const deleteHandbookContractor = async (contractor_id) => {
  try {
    const res = await contractorsAPI.deleteContractor(contractor_id);
    return res?.data;
  } catch (e) {}
};
export const getCity = async () => {
  try {
    const res = await contractorsAPI.getCity();
    return res?.data;
  } catch (e) {}
};
export const getTaxopark = async () => {
  try {
    const res = await contractorsAPI.getTaxopark();
    return res?.data;
  } catch (e) {}
};
export const getContractorType = async () => {
  try {
    const res = await contractorsAPI.getContractorType();
    return res?.data;
  } catch (e) {}
};
export const getContragentType = async () => {
  try {
    const res = await contractorsAPI.getContragentType();
    return res?.data;
  } catch (e) {}
};
export const getContractorMainType = async () => {
  try {
    const res = await contractorsAPI.getContractorMainType();
    return res?.data;
  } catch (e) {}
};

export const mapSBSCompany = async (body) => {
  try {
    const res = await contractorsAPI.mapSBSCompany(body);
    return res?.data;
  } catch (e) {}
};

export const mapSBSPartner = async (body) => {
  try {
    const res = await contractorsAPI.mapSBSPartner(body);
    return res?.data;
  } catch (e) {}
};

export const getContractTextType = async () => {
  try {
    const res = await contractorsAPI.getContractTextType();
    return res?.data;
  } catch (e) {}
};

export const contractorsColumns = [
  { name: "contractor_id", field: "ID", label: "ID", align: "center" },
  {
    name: "contractor_name",
    field: "contractor_name",
    label: "Наименование",
    align: "center",
  },
  {
    name: "snr",
    field: "snr",
    label: "Режим налогообложения (СНР) / ОКЭД",
    align: "center",
  },
  {
    name: "director_fio",
    field: "director_fio",
    label: "ФИО директора",
    align: "center",
  },
  {
    name: "assign_type_name",
    field: "assign_type_name",
    label: "Тип назначения",
    align: "center",
  },
  {
    name: "documents",
    field: "documents",
    label: "Документы",
    align: "center",
  },
  {
    name: "legal_name",
    field: "legal_name",
    label: "Юридическое наименование",
    align: "center",
  },
  { name: "city_name", field: "city_name", label: "Город", align: "center" },
  {
    name: "account_name",
    field: "account_name",
    label: "Банковские реквизиты",
    align: "center",
  },
  {
    name: "accession_contract_num",
    field: "accession_contract_num",
    label: "Договор",
    align: "center",
  },
  {
    name: "agreement_postavka_guid",
    field: "agreement_postavka_guid",
    label: "GUID договора поставки",
    align: "center",
  },
  {
    name: "contacts",
    field: "contacts",
    label: "Контактная информация",
    align: "center",
  },
  {
    name: "is_send_to_1c_text",
    field: "is_send_to_1c_text",
    label: "1C",
    align: "center",
  },
  { name: "edit", field: "edit", label: "Действия", align: "center" },
];
